export const isTokenValid = () => {
    const tokenExpiration = localStorage.getItem("tokenExpiration");

    if (tokenExpiration && new Date().getTime() < parseInt(tokenExpiration)) {
      return true;
    }

    return false;
};